import { getAttempts } from '../utils/localStorage';

const TOPICS = [
  { id: 1, label: 'Vienādu daļu salīdzinājumi',                       emoji: '⚖️'  },
  { id: 2, label: 'Saskaitīšana un atņemšana ar vienādiem saucējiem',  emoji: '➕'  },
  { id: 3, label: 'Daļas no skaitļa',                                  emoji: '🔢'  },
  { id: 4, label: 'Daļu vārdi ciparu formātā',                         emoji: '📝'  },
  { id: 5, label: 'Atrast daļu uz skaitļu taisnes',                    emoji: '📏'  },
  { id: 6, label: 'Atrast nezināmo skaitli (daļa no x = skaitlis)',    emoji: '🔍'  },
];

function dotColor(score, total) {
  const pct = score / total;
  if (pct >= 0.8) return 'var(--color-success)';
  if (pct >= 0.5) return 'var(--color-warning)';
  return 'var(--color-danger)';
}

export default function HomePage({ onStart }) {
  return (
    <div className="home-page">
      <h1 className="home-title">Daļu Viktorīna</h1>
      <p className="home-subtitle">Izvēlies tēmu, lai sāktu viktorīnu:</p>

      <div className="topic-list">
        {TOPICS.map(topic => {
          const attempts = getAttempts(topic.id);
          const best = attempts.length > 0
            ? Math.max(...attempts.map(a => a.score))
            : null;
          const total = attempts.length > 0 ? attempts[0].total : 10;

          return (
            <div key={topic.id} className="topic-card">
              <button
                className="topic-btn"
                onClick={() => onStart(topic.id)}
              >
                <span className="topic-emoji">{topic.emoji}</span>
                <span className="topic-label">{topic.label}</span>
              </button>

              <div className="topic-history">
                {attempts.length === 0 ? (
                  <span className="no-attempts">Nav mēģinājumu</span>
                ) : (
                  <>
                    <span className="best-score">
                      Labākais: {best}/{total}
                    </span>
                    <div className="attempt-dots">
                      {attempts.slice(0, 5).map((a, i) => (
                        <span
                          key={i}
                          className="attempt-dot"
                          title={`${a.score}/${a.total} — ${new Date(a.date).toLocaleDateString('lv')}`}
                          style={{ background: dotColor(a.score, a.total) }}
                        />
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
